/* Apple Watch fields; no price changes. Source of measurements: cstrap-apw-fields.liquid. Same pattern as cstrap-pam.js. */
(function () {
  'use strict';
  if (window.CSTRAP_APW) return;
  function active(root) {
    var c = root.querySelector('input[name="properties[Style of Strap]"]:checked');
    return !!c && /^Apple Watch /.test(c.value);
  }
  function config(root) {
    var node = root.querySelector('[data-apw-config]');
    return node ? JSON.parse(node.textContent) : null;
  }
  window.CSTRAP_APW = {
    active: active,
    thickness: function (root, padding) {
      var cfg = config(root);
      if (!cfg || !active(root)) return null;
      var kind = padding === 'Flat' ? 'Flat' : /^Padded/.test(padding) ? 'Padded' : '';
      var allowed = cfg.thickness[kind] || [];
      var seen = {}, options = [];
      cfg.thickness.Flat.concat(cfg.thickness.Padded).forEach(function (v) {
        if (seen[v]) return;
        seen[v] = 1;
        options.push({ value: v, disabled: allowed.indexOf(v) < 0 });
      });
      options.push({ value: 'Request custom thickness', label: 'Other', disabled: !kind });
      return options;
    }
  };
  function init(root) {
    var cfg = config(root), box = root.querySelector('[data-apw-fields]');
    if (!cfg || !box || box.dataset.apwReady) return;
    box.dataset.apwReady = '1';
    var sid = root.id.replace(/^cstrap-/, '');
    var form = root.querySelector('form[id^="cstrap-form-"]');
    var padding = root.querySelector('select[name="properties[Strap form]"]');
    var sizeSel = box.querySelector('[data-apw-size]'), lugSel = box.querySelector('[data-apw-lug]');
    var previous = null, suppressed = [];
    var adapterIn = box.querySelector('[data-apw-adapter]');
    var radios = [].slice.call(root.querySelectorAll('input[type="radio"][name="properties[Buckle Finish]"]'));
    var noneRadio = radios.filter(function (r) { return r.value === 'None'; })[0];
    var fallbackRadio = radios.filter(function (r) { return r.value === 'Classic — Silver'; })[0];
    var note = null, labelNode = null, labelText = '', helpBtn = null;
    // "?" next to Style of Strap, shown only for Apple Watch styles: opens the shared help popup with the Apple Watch guide (template in cstrap-apw-fields.liquid).
    (function () {
      var st = root.querySelector('input[name="properties[Style of Strap]"]');
      var stLabel = st && st.closest('.cfield') && st.closest('.cfield').querySelector('.cfield__label');
      if (!stLabel) return;
      helpBtn = document.createElement('button');
      helpBtn.type = 'button'; helpBtn.className = 'chelp capw__help'; helpBtn.hidden = true;
      helpBtn.setAttribute('data-help-title', 'Style of Strap (Apple Watch)');
      helpBtn.setAttribute('data-help-text', ' ');
      helpBtn.setAttribute('data-help-art', 'apwguide');
      helpBtn.innerHTML = '<svg class="chelp__i" viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="8" cy="8" r="6.4"/><path d="M6.15 6.25a1.85 1.85 0 1 1 2.55 1.72c-.47.2-.7.56-.7 1.01v.36" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="11.6" r=".6" fill="currentColor" stroke="none"/></svg>';
      helpBtn.setAttribute('aria-label', 'Apple Watch strap guide');   /* 23/10 sep: chi dau "?", khong chu Guide */
      stLabel.appendChild(helpBtn);
    })();
    // "Adapter included in the same finish." sits right under the Buckle Finish label; shown only while Apple Watch is chosen.
    if (radios.length) {
      var lab = radios[0].closest('.cfield') && radios[0].closest('.cfield').querySelector('.cfield__label');
      if (lab) {
        note = document.createElement('p'); note.className = 'capw__note'; note.hidden = true;
        note.textContent = 'Adapter and buckle come in the same finish.';
        lab.insertAdjacentElement('afterend', note);
        for (var i = 0; i < lab.childNodes.length; i++) {
          if (lab.childNodes[i].nodeType === 3 && /\S/.test(lab.childNodes[i].data)) { labelNode = lab.childNodes[i]; break; }
        }
        if (labelNode) labelText = labelNode.data;
      }
    }
    // Apple Watch shows each buckle tile as the adapter + buckle set in the same finish (picture + label only; the value stays "Classic — Silver" etc).
    function setFile(value) {
      var c = { 'Silver': 'silver', 'Gold': 'gold', 'Rose Gold': 'rosegold', 'Black': 'black' }[finish(value)];
      if (!c) return '';
      return /^Classic/.test(value) ? 'apw-buckle-' + c + '.webp' : /^Pre-V/.test(value) ? 'apw-set-prev-' + c + '.webp' : /^Butterfly/.test(value) ? 'apw-set-butterfly-' + c + '.webp' : '';
    }
    function swapImages(on) {
      if (labelNode) labelNode.data = on ? labelText.replace(/Buckle Finish/i, 'Adapter & Buckle') : labelText;
      radios.forEach(function (r) {
        var img = r.closest('label') && r.closest('label').querySelector('.sw-img img');
        if (!img) return;
        if (!img.dataset.apwSrc) { img.dataset.apwSrc = img.getAttribute('src'); img.dataset.apwZoom = img.getAttribute('data-zoom-src') || ''; }
        var f = on ? setFile(r.value) : '';
        if (f) {
          img.setAttribute('src', img.dataset.apwSrc.replace(/[^\/?]+\.webp/, f));
          if (img.dataset.apwZoom) img.setAttribute('data-zoom-src', img.dataset.apwZoom.replace(/[^\/?]+\.webp/, f));
        } else {
          img.setAttribute('src', img.dataset.apwSrc);
          if (img.dataset.apwZoom) img.setAttribute('data-zoom-src', img.dataset.apwZoom);
        }
      });
    }
    function finish(value) {
      return /Rose Gold/i.test(value) ? 'Rose Gold' : /Silver/i.test(value) ? 'Silver' : /Black/i.test(value) ? 'Black' : /Gold/i.test(value) ? 'Gold' : '';
    }
    function adapter(on) {
      var c = radios.filter(function (r) { return r.checked; })[0];
      adapterIn.value = on && c ? finish(c.value) : '';
      adapterIn.disabled = !on || !adapterIn.value;
      if (on && adapterIn.value) adapterIn.name = 'properties[Adapter]'; else adapterIn.removeAttribute('name');
    }
    function emit(el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); }
    function options(select, values) {
      values.forEach(function (value) { var op = document.createElement('option'); op.value = value; op.textContent = value; select.appendChild(op); });
    }
    options(sizeSel, cfg.sizes);
    var lugHolder = lugSel.options[0].textContent;
    // Lug Width depends on the Apple Watch size (cfg.lugBySize); no size yet = disabled; a size change that makes the chosen lug invalid resets it.
    function lugs() {
      var list = ((cfg.lugBySize && cfg.lugBySize[sizeSel.value]) || []).map(function (v) { return v + ' mm'; }), cur = lugSel.value;
      while (lugSel.options.length > 1) lugSel.remove(1);
      options(lugSel, list);
      lugSel.value = cur && list.indexOf(cur) > -1 ? cur : '';
      lugSel.options[0].textContent = sizeSel.value ? 'Select lug width' : lugHolder;
      lugSel.disabled = !sizeSel.value || box.hidden;
      return cur !== lugSel.value;
    }
    sizeSel.addEventListener('change', function () { if (lugs()) emit(lugSel); });
    function dimensions(on) {
      box.hidden = !on;
      if (helpBtn) helpBtn.hidden = !on;
      sizeSel.disabled = !on;
      lugs();
      if (on) { sizeSel.name = 'properties[Apple Watch Size]'; lugSel.name = 'properties[Lug Width]'; }
      else { sizeSel.removeAttribute('name'); lugSel.removeAttribute('name'); }
      adapter(on);
    }
    function suppress(node, list) {
      list = list || suppressed;
      if (!node) return;
      var state = { node: node, hidden: node.hidden, fields: [] };
      node.querySelectorAll('input, select, textarea').forEach(function (el) {
        state.fields.push({ el: el, disabled: el.disabled, required: el.required });
        el.disabled = true; el.required = false;
      });
      node.hidden = true; list.push(state);
    }
    function restore(list) {
      list = list || suppressed;
      list.forEach(function (state) {
        state.node.hidden = state.hidden;
        state.fields.forEach(function (f) { f.el.disabled = f.disabled; f.el.required = f.required; });
      });
      list.length = 0;
    }
    // Same as cstrap-khoa-folding.js: click the tile without letting the browser scroll to it.
    function pick(r) {
      var x = window.scrollX, y = window.scrollY, a = document.activeElement;
      (r.closest('label') || r).click();
      var back = function () { if (window.scrollY !== y || window.scrollX !== x) window.scrollTo(x, y); };
      back();
      if (a && a !== document.body && a.focus) { try { a.focus({ preventScroll: true }); } catch (e) {} }
      requestAnimationFrame(back); setTimeout(back, 60);
    }
    // Apple Watch: adapter + buckle are one set, so "None" is not offered; leaving Apple Watch brings it back.
    function noBuckle(on) {
      if (note) note.hidden = !on;
      swapImages(on);
      if (!noneRadio) return;
      noneRadio.disabled = on;
      if (on && noneRadio.checked && fallbackRadio) pick(fallbackRadio);
    }
    function sync() {
      var on = active(root);
      dimensions(on);
      // The engine un-hides fields on every style change (also Apple Watch -> Apple Watch); keep ours hidden.
      suppressed.forEach(function (state) { state.node.hidden = true; });
      if (on === previous) return;
      var was = previous; previous = on;
      root.classList.toggle('is-apw', on);
      noBuckle(on);
      adapter(on);
      if (on) {
        var lug = document.getElementById('cf-' + sid + '-lug-width');
        suppress(lug && lug.closest('.cfield'));
        suppress(document.getElementById('ccustom-lug-' + sid));
        var spring = root.querySelector('[name="properties[Spring bar]"]');
        suppress(spring && spring.closest('.cfield'));
        // 23/10 sep: Apple Watch strap is never curved -> Curved End back to "No" (End Shape Straight, no +$15), then hide the field.
        // Set while the radios are still enabled and fire change so the engine drops the +$15 and the End Shape variant.
        var curved = root.querySelector('[data-curved-end]');
        var curvedNo = curved && [].slice.call(curved.querySelectorAll('input[type="radio"]')).filter(function (r) { return r.value === 'No'; })[0];
        if (curvedNo && !curvedNo.checked) { curvedNo.checked = true; curvedNo.dispatchEvent(new Event('change', { bubbles: true })); }
        suppress(curved && (curved.closest('.cfield') || curved));
        if (padding && !padding.value) padding.value = 'Flat';
      } else if (was) {
        restore();
      }
      if (on || was) emit(padding); // Rebuild thickness through the existing engine and refresh summary.
    }
    // Order against cstrap-pam.js on Bespoke (both suppress / restore the same lug fields): leaving Apple Watch restores
    // BEFORE PAM suppresses (capture phase); entering Apple Watch suppresses AFTER PAM has restored (next tick).
    root.addEventListener('change', function (event) {
      // Capture phase: the adapter value is set before the engine rebuilds the summary / cart properties.
      if (event.target.name === 'properties[Buckle Finish]') adapter(previous === true);
      if (event.target.name !== 'properties[Style of Strap]') return;
      if (active(root)) setTimeout(sync, 0); else sync();
    }, true);
    // Back/forward navigation can restore select values without firing change.
    window.addEventListener('pageshow', sync);
    if (form) form.addEventListener('submit', sync, true);
    sync();
  }
  function initAll() { document.querySelectorAll('.cstrap-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
